import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CourseDetail, CourseTable } from 'types';
import {
    Announcement,
    Content,
    Description,
    DurationText,
    Tag,
    TagBlock,
    Title,
} from './styled';
import { CourseTemplate, EventType } from 'types/enums';
import DOMPurify from 'dompurify';
import { ButtonBlock, ButtonClick, ButtonLink } from '../styled';

interface IProps {
    course: CourseTable;
    openCourseRegister?: (course: CourseDetail) => void;
}

export const CourseItem: FC<IProps> = ({ course, openCourseRegister }) => {
    const { t } = useTranslation(['common/shared', 'pages/courses']);
    return (
        <Content>
            <Description>
                <TagBlock>
                    {course.isFree && (
                        <Tag variant={'green'}>{t('common/shared:free')}</Tag>
                    )}
                    {process.env.REACT_APP_LOCALE === 'en' &&
                        course.studyForms.map((r) => (
                            <Tag
                                variant={
                                    r === EventType.Offline
                                        ? 'white'
                                        : 'default'
                                }
                                key={`study-form-key-${r}`}>
                                {t(`common/shared:studyForm-${r}`)}
                            </Tag>
                        ))}
                    {process.env.REACT_APP_LOCALE === 'ru' &&
                        course.forWhom.map((r) => (
                            <Tag variant={'default'} key={`for-whom-key-${r}`}>
                                {t(`common/shared:forWhom-${r}`)}
                            </Tag>
                        ))}
                </TagBlock>
                <Title to={`/course/${course.groupName}`}>{course.name}</Title>
                <Announcement
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                            course.announcementDescription
                        ),
                    }}
                />
                <DurationText>{course?.duration ?? ''}</DurationText>
                <ButtonBlock>
                    {course.template === CourseTemplate.Awareness ? (
                        <ButtonLink
                            as={'a'}
                            target={'_blank'}
                            href={course.demoLink}>
                            {t('common/shared:leave-request')}
                        </ButtonLink>
                    ) : course.template === CourseTemplate.Product ? (
                        <ButtonLink
                            as={'a'}
                            target={'_blank'}
                            href={course.buyLink}>
                            {t('common/shared:find-provider')}
                        </ButtonLink>
                    ) : course.template === CourseTemplate.Usual ? (
                        <ButtonClick
                            onClick={() =>
                                openCourseRegister &&
                                openCourseRegister(course as CourseDetail)
                            }>
                            {t('common/shared:leave-request')}
                        </ButtonClick>
                    ) : course.template === CourseTemplate.XTraining ? (
                        <ButtonLink
                            as={'a'}
                            target={'_blank'}
                            href={course.buyLink}>
                            {t('common/shared:buy')}
                        </ButtonLink>
                    ) : null}

                    <ButtonLink to={`/course/${course.groupName}`}>
                        {t('common/shared:know-more')}
                    </ButtonLink>
                </ButtonBlock>
            </Description>
        </Content>
    );
};
